import React, { useState, useEffect, useContext } from 'react'
import { useAsyncEffect } from 'use-async-effect'
// Styles
import { ItemWrapper } from 'styles/common'
// Compornents
import MatchMapForm from './Form'
import Loading from 'components/utils/Loading'
import Warning from 'components/utils/Warning'
// Additional
import { Tab } from 'static/tabs'
import { Text } from 'static/text'
import { AppContext } from 'App'
import { MatchMapVetoRecord } from 'data/MatchMapVetoRecord'
import { MatchMapVetoContext } from 'components/MatchMapVetos/__MatchMapVetos.context'
import { Routing as RoutingHelper } from 'helpers/routing'
import { Data as DataHelper } from 'helpers/data'

const Detail: React.FC<{ isNew?: boolean }> = (p) => {
  const {
    db: a_db,
    alert: a_alert,
    locked: a_locked,
    location: a_location,
  } = useContext(AppContext)

  const { params: mmv_params } = useContext(MatchMapVetoContext)
  const isNewRecord = RoutingHelper.getIsNewRecord(
    mmv_params?.match_map_veto_id ?? RoutingHelper.NewRecordSymbol
  )

  // --------------------- Load Data --------------------- //
  const [content, setContent] = useState<{
    data?: MatchMapVetoRecord
    load: {
      isInProgress?: boolean
      isError?: boolean
    }
  }>()

  useAsyncEffect(async () => {
    if (isNewRecord || !mmv_params?.match_map_veto_id) return

    setContent((prev) => ({ ...prev, load: { isInProgress: true } }))

    try {
      const _data = await DataHelper.getMatchMapVetosById(
        a_db!,
        mmv_params?.match_map_veto_id,
        { alert: a_alert }
      )

      setContent((prev) => ({
        ...prev,
        data: _data,
        load: { isInProgress: false },
      }))
    } catch {
      setContent((prev) => ({
        ...prev,
        load: { isInProgress: false, isError: true },
      }))
    }
  }, [mmv_params?.match_map_veto_id])

  // -------------------- Set Location ------------------- //
  const _setLocation = (data?: MatchMapVetoRecord) => {
    a_location?.set?.(Tab.MatchMapVetos)
  }

  useEffect(() => {
    _setLocation(content?.data)
  }, [content?.data, isNewRecord])

  // ---------------------- Handlers --------------------- //
  const handleLockedChange = (isLocked: boolean) => {
    a_locked?.set(isLocked)
  }

  if (content?.load.isError) return <Warning text={Text.NoServerData} />

  if (content?.load.isInProgress) return <Loading />

  return (
    <>
      <ItemWrapper>
        <MatchMapForm
          data={content?.data}
          state={isNewRecord ? 'new' : 'existing'}
          locked={{
            value: a_locked?.value ?? false,
            callback: handleLockedChange,
          }}
          submitCallback={_setLocation}
        />
      </ItemWrapper>
    </>
  )
}

export default Detail
